import { gql } from '@apollo/client';

export const getWhatsAppTemplates = gql`
  query GetWhatsAppTemplates($where: whatsapp_template_bool_exp) {
    whatsapp_template(where: $where, order_by: { updated_at: desc }) {
      id
      meta_template_id
      meta_template_name
      language
      category
      status
      body_preview
      variable_count
      variable_labels
      notes
      components
      last_synced_at
      updated_at
    }
  }
`;

export const updateWhatsAppTemplate = gql`
  mutation UpdateWhatsAppTemplate(
    $id: uuid!
    $changes: whatsapp_template_set_input!
  ) {
    update_whatsapp_template_by_pk(pk_columns: { id: $id }, _set: $changes) {
      id
      variable_labels
      notes
    }
  }
`;

export const getLeadPlaybooks = gql`
  query GetLeadPlaybooks {
    lead_playbook(order_by: { name: asc }) {
      id
      name
      slug
      description
      is_active
      archetype_filters
      lead_playbook_steps(order_by: { sort_order: asc }) {
        id
        name
        sort_order
        trigger_type
        cadence_day
        cadence_slot
        channel
        send_mode
        missive_response_id
        llm_prompt
        is_active
        whatsapp_template {
          id
          meta_template_name
          status
        }
      }
    }
  }
`;

export const insertLeadPlaybook = gql`
  mutation InsertLeadPlaybook($object: lead_playbook_insert_input!) {
    insert_lead_playbook_one(object: $object) {
      id
      name
      slug
    }
  }
`;

export const insertLeadPlaybookStep = gql`
  mutation InsertLeadPlaybookStep($object: lead_playbook_step_insert_input!) {
    insert_lead_playbook_step_one(object: $object) {
      id
      name
    }
  }
`;

export const updateLeadPlaybookStep = gql`
  mutation UpdateLeadPlaybookStep(
    $id: uuid!
    $changes: lead_playbook_step_set_input!
  ) {
    update_lead_playbook_step_by_pk(pk_columns: { id: $id }, _set: $changes) {
      id
      is_active
    }
  }
`;

export const updateLeadPlaybook = gql`
  mutation UpdateLeadPlaybook($id: uuid!, $changes: lead_playbook_set_input!) {
    update_lead_playbook_by_pk(pk_columns: { id: $id }, _set: $changes) {
      id
      is_active
    }
  }
`;

export const deleteLeadPlaybookStep = gql`
  mutation DeleteLeadPlaybookStep($id: uuid!) {
    delete_lead_playbook_step_by_pk(id: $id) {
      id
    }
  }
`;

export const deleteWhatsAppTemplate = gql`
  mutation DeleteWhatsAppTemplate($id: uuid!) {
    delete_whatsapp_template_by_pk(id: $id) {
      id
    }
  }
`;

export const getLeadAutomationLogs = gql`
  query GetLeadAutomationLogs($limit: Int!) {
    lead_automation_log(order_by: { created_at: desc }, limit: $limit) {
      id
      channel
      send_mode
      status
      missive_url
      error_message
      created_at
      lead {
        id
        content
      }
      lead_playbook_step {
        name
      }
    }
  }
`;
